var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSortIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.31344 0.146447C3.5087 -0.0488155 3.82528 -0.0488155 4.02055 0.146447L6.52055 2.64645C6.71581 2.84171 6.71581 3.15829 6.52055 3.35355C6.32528 3.54882 6.0087 3.54882 5.81344 3.35355L4.16699 1.70711V15.5C4.16699 15.7761 3.94313 16 3.66699 16C3.39085 16 3.16699 15.7761 3.16699 15.5V1.70711L1.52055 3.35355C1.32528 3.54882 1.0087 3.54882 0.813439 3.35355C0.618177 3.15829 0.618177 2.84171 0.813439 2.64645L3.31344 0.146447ZM10.3337 1.49012e-08C10.6098 1.49012e-08 10.8337 0.223858 10.8337 0.5V14.2929L12.4801 12.6464C12.6754 12.4512 12.992 12.4512 13.1872 12.6464C13.3825 12.8417 13.3825 13.1583 13.1872 13.3536L10.6872 15.8536C10.492 16.0488 10.1754 16.0488 9.98011 15.8536L7.48011 13.3536C7.28484 13.1583 7.28484 12.8417 7.48011 12.6464C7.67537 12.4512 7.99195 12.4512 8.18721 12.6464L9.83366 14.2929V0.5C9.83366 0.223858 10.0575 1.49012e-08 10.3337 1.49012e-08Z",
    fill: "#444444"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortIcon);
export default __webpack_public_path__ + "static/media/sort-icon.98ceab4fc3cd24ad4d78c4a0671393de.svg";
export { ForwardRef as ReactComponent };